<template>
    <div class="mb-4">
        <pc-label
            v-bind:label="testTVRLabel"
            bold />
        <div class="d-flex mx-1 mb-1 mt-2">
            <pc-bs-icon
                v-if="isRuleSchemaValid"
                name="check-circle"
                class="mx-1 mt-1"
                style="color: green; min-width: 1rem" />
            <pc-bs-icon
                v-else
                name="x-circle"
                class="mx-1 mt-1"
                style="color: red; min-width: 1rem" />
            <div>{{ ruleSchemaConfigurationMessage }}</div>
        </div>
        <pc-input
            ref="textboxinput"
            v-model="input"
            class="mb-4"
            alt-label="testRule"
            v-bind:validator="validator"
            v-bind:external-validation-result="lastValidationResult"
            v-bind:disabled="!isRuleSchemaValid"
            immediate-validation
            v-on:validated="saveLastValidationResult" />
    </div>
</template>

<script>
    import { mapI18n } from "Util/i18n";
    import { NAMESPACE, KEYS } from "./i18n/textValidationRulesTab.i18n";
    import { ALERT_SEVERITY } from "Util/alerts";
    import { getTextValidationRuleValidatorOptions } from "./textValidationRuleValidationHelpers";
    import { getValidator } from "Validation/validator";

    export default {
        props: {
            ruleSchema: { type: Object, required: true, default: null },
            validationErrorMessage: { type: String, required: true },
            ruleType: { type: Number, required: true },
            isRuleSchemaValid: { type: Boolean, required: true },
            defaultErrorMessage: { type: String, required: true }
        },
        data() {
            return {
                input: "",
                alertSeverityError: ALERT_SEVERITY.error,
                validator: null,
                lastValidationResult: { hasError: false }
            };
        },
        computed: {
            ruleSchemaConfigurationMessage() {
                return this.isRuleSchemaValid
                    ? this.ruleSchemaConfigurationIsValid
                    : this.invalidRuleSchemaConfiguration;
            },
            ...mapI18n(KEYS, NAMESPACE)
        },
        watch: {
            validationErrorMessage() {
                this.setValidator();
            },
            async ruleSchema() {
                this.setValidator();
                await this.$nextTick();
                this.$refs.textboxinput.validate();
            }
        },
        methods: {
            setValidator() {
                if (this.isRuleSchemaValid) {
                    let errorMessage = this.validationErrorMessage;

                    if (!errorMessage || errorMessage.trim() === "") {
                        errorMessage = this.defaultErrorMessage;
                    }

                    const validatorOptions = getTextValidationRuleValidatorOptions(
                        this.ruleType,
                        this.ruleSchema,
                        errorMessage
                    );

                    this.validator = getValidator(this.$app, validatorOptions);

                    if (this.lastValidationResult && this.lastValidationResult.hasError) {
                        this.lastValidationResult = { hasError: true, error: errorMessage };
                    }
                } else {
                    this.validator = null;
                    this.lastValidationResult = null;
                }
            },
            saveLastValidationResult(result) {
                this.lastValidationResult = result;
            }
        }
    };
</script>
